<div class="text-center">
  @if (!userCreated) {
  <form [formGroup]="createUserForm" (ngSubmit)="createNewUser()">
    <mat-card-header>
      <h3 class="welcome-text"> {{'LOGIN.SIGN_UP' | transloco }}
      </h3>
    </mat-card-header>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'LOGIN.LANGUAGE' | transloco }}</mat-label>
      <mat-select formControlName="language">
        @for (lang of languages; track lang) {
        <mat-option [value]="lang.value">
          {{ lang.viewValue }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'LOGIN.FIRST_NAME' | transloco }}</mat-label>
      <input matInput placeholder="{{ 'LOGIN.FIRST_NAME' | transloco }}" formControlName="firstname">
      <mat-icon matSuffix>person</mat-icon>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'LOGIN.LAST_NAME' | transloco }}</mat-label>
      <input matInput placeholder="{{ 'LOGIN.LAST_NAME' | transloco}}" formControlName="lastname">
      <mat-icon matSuffix>person</mat-icon>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" formControlName="email" [errorStateMatcher]="matcher">
      <mat-icon matSuffix>email</mat-icon>
    </mat-form-field>
    <div class="signup-buttons">
      <button mat-raised-button class="mr-2" color="warn" type="button" (click)="cancelForm()"
        [disabled]="createUserForm.pristine || loading">
        {{ 'LOGIN.CANCEL' | transloco }}
      </button>
      <button mat-raised-button color="primary" type="submit" [disabled]="!createUserForm.valid || loading">
        {{ 'LOGIN.REGISTER' | transloco }}
      </button>
    </div>
  </form>
  }

  @if (userCreated) {
  <div>
    <h3>{{ 'LOGIN.REGISTRATION_SUCCESS' | transloco }}</h3>
    <p>{{ 'LOGIN.EMAIL_VERIFICATION_MESSAGE' | transloco }}</p>
    <button mat-raised-button color="primary" (click)="goToLogin()" class="mt-3">
      {{ ('LOGIN.SIGN_IN' | transloco) | uppercase }}
    </button>
  </div>
  }

</div>